
































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { IDelegate } from "@/models/delegates";
import { TranslateResult } from "vue-i18n";
import ClientMixin from "@/mixins/clientMixin";
import i18n from "@/i18n";
import _ from "@/boot/lodash";

@Component
export default class DelegatesDropdownList extends Mixins(ClientMixin) {
  // Props

  @Prop({ required: true })
  public readonly delegates!: IDelegate[];

  @Prop({ default: () => i18n.t("_.record") })
  public readonly objectType!: TranslateResult;

  // Computed

  public get activeDelegates() {
    return _.map(
      _.filter(this.delegates, ["active", true]),
      (delegate: IDelegate) => delegate.client
    );
  }

  public get invitedDelegates() {
    return _.filter(this.delegates, ["active", false]);
  }

  public get showDivider() {
    return !!this.activeDelegates.length && !!this.invitedDelegates.length;
  }
}
